import { Plus } from 'lucide-react';

interface QuickAddFABProps {
  onClick: () => void;
}

export default function QuickAddFAB({ onClick }: QuickAddFABProps) {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-28 right-6 z-[85] bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-[var(--text-inverse)] rounded-full p-4 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 active:scale-95 flex items-center justify-center group"
      title="Quick Add (⌘I)"
      type="button"
    >
      <Plus size={24} className="group-hover:rotate-90 transition-transform duration-200" />
    </button>
  );
}
